import { OrganizationCategory } from "app/infrastructure/model/interfaces/organizationCategory.interface";
import { EntitySubscription } from "app/infrastructure/model/interfaces/entitySubscription.interface";

export class ProductReport {
  id?: string;
  systemCode: string;
  businessCode: string;
  productCode: string;
  productReportCode: string;
  configurationType?: string;
  fileURL?: string;
  thumbnail?: string;
  description: string;
  descriptionEXT: string;
  status: string;
  boundRuleId?: Number;
  mappingAttributes?: MappingProductReportAttribute[];
  urlImage?: string;
  rules?: ProductReportRule[];
  creado?: string;
  modificado?: string;
  fechaCreacion?: Date;
  fechaActualizacion?: Date;
  category?: ProductReportCategories;
  standardDictionary?: ProductReportStandardDictionary;
  constructor(){
      this.category ={
          id: null,
          description:''
      }
      this.standardDictionary ={
          id: null,
          name:''
      }
  }
}


export interface MappingProductReportAttribute {
  id?: number;
  attribute: string;
  type: string;
  productReportCode?: string;
  systemCode?: string;
  businessCode?: string;
  productCode?: string;
  status?: string;
  creado?: string;
  modificado?: string;
  fechaCreacion?: Date;
  fechaActualizacion?: Date;
  mappingRule?: string;
}

export interface MappingResponse{
  fileUrl : string;
  attributes : MappingProductReportAttribute[];
}


// This model is used for the detail over the output
export interface MappingProductReportAttributeModel {
  id?: number;
  attribute: string;
  type: string;
  sourceKey: string;
  attributeKey: string;
  rulePrototype: string;
  productReportCode?: string;
  systemCode?: string;
  businessCode?: string;
  productCode?: string;
}

export interface ProductReportRule {
  id?: number;
  ruleId?: number;
  description?: string;
  active?: boolean;
}
export interface ProductReportCategories {
  id: string;
  description: string;
}
export interface ProductReportStandardDictionary {
  id: string;
  name: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/classes/productReport.class.ts